export default "__VITE_ASSET__CG2lDgJq__"